exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.my-container[data-v-50e4f40e]{\n    height: calc(100vh);\n    margin-left:170px;\n    background-color: #F8F9FA;\n}\n", ""]);

